// PrescriptionLayout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

const PrescriptionLayout = () => {
  const [prescriptionData, setPrescriptionData] = useState(null);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PrescriptionLayout;
